import classes from "./ReleaseActivityPage.module.css";
import {POLL_SHARE_MODE, POLL_STATE, POLL_TYPE} from "../../utils/constants";
import {useClassResultsAnalysisManager} from "../../hooks/useClassResultsAnalysisManager";
import ViewMetricCardParticipants from "./ViewMetricCardParticipants";
import ViewMetricCardActivityFeed from "./ViewMetricCardActivityFeed";
import ViewMetricCardResponses from "./ViewMetricCardResponses";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";

export default function ViewMetricCards({
                                            pollData,
                                            activeStudents,
                                            responseData,
                                            participantData,
                                            participantsOverallData,
                                            curQuestionNo,
                                            isActivityEnded,
                                            localState
}) {
    const {poll={}, questions=[]} = pollData;
    const [, getTimeOffset] = useLocalStorageNew("timeOffset", 0);
    const stableScrollBarContainerStyle = {scrollbarGutter: "stable", overflowY: "hidden", paddingLeft: 4, paddingRight: 2};





    if (poll.pollShareMode === POLL_SHARE_MODE.UNKNOWN
        || (
            poll.pollShareMode === POLL_SHARE_MODE.SCHEDULE
            && localState !== "SHARED_ALL"
            && localState !== "TIMEUP_ALL"
        ) //scheduled poll is not started yet
        || (poll.pollShareMode === POLL_SHARE_MODE.SHARE_ALL && !questions.filter(q => !!q.shareCount).length)
        || (poll.pollType === POLL_TYPE.ATTENDANCE && !questions.filter(q => !!q.shareCount).length)
    ) {
        return <></>;
    }


    return (
        <div
            className={classes.column}
            style={{...stableScrollBarContainerStyle, width: 280, height: "100%", overflowY: 'auto', gap: 10}}
        >
            {isActivityEnded
                ? <ViewMetricCardResponses
                    pollData={pollData}
                    dataResponses={responseData}
                    curQuestionNo={curQuestionNo}
                />

                : <ViewMetricCardParticipants
                    pollData={pollData}
                    data={participantData}
                    dataAll={participantsOverallData}
                    curQuestionNo={curQuestionNo}
                />

            }

            {/*we show this data only when activity is on sharing*/}
            {((poll.pollType !== POLL_TYPE.ATTENDANCE
                && poll.pollShareMode === POLL_SHARE_MODE.SHARE_EACH
                && !!poll.pollEnded)
                    || localState === "GET_READY_ALL"
                    || localState === "SHARED_ALL"
                    || localState === "GET_READY"
                    || localState === "SHARED") &&
                <ViewMetricCardActivityFeed
                    data={activeStudents}
                    pollType={poll.pollType}
                />
            }


        </div>
    );
}